import * as Yup from "yup";
import { School, Engineering, LocalLibrary, Build, Badge, Handyman, Science, Work } from "@mui/icons-material";

export const STATUS_OPTIONS = [
    { value: "started", label: "Iniciado" },
    { value: "design_filled", label: "Design Preenchido" },
    { value: "invoice_generated", label: "Fatura Gerada" },
    { value: "invoice_details_advanced", label: "Detalhes da Fatura Avançados" },
    { value: "student_details_filled", label: "Detalhes do Estudante Preenchidos" },
    { value: "photo_uploaded", label: "Foto Carregada" },
    { value: "personal_identification_uploaded", label: "Identificação Pessoal Carregada" },
    { value: "institution_identification_filled", label: "Identificação da Instituição Preenchida" },
    { value: "waiting_review", label: "Aguardando Revisão" },
    { value: "approved", label: "Aprovado" },
    { value: "adjustments_requested", label: "Ajustes Solicitados" },
    { value: "rejected", label: "Rejeitado" },
    { value: "blocked", label: "Bloqueado" },
];

export const COURSE_TYPES = [
  { label: "Ensino Infantil", icon: <School />, value: "Ensino Infantil" },
  { label: "Ensino Fundamental", icon: <School />, value: "Ensino Fundamental" },
  { label: "Ensino Médio", icon: <School />, value: "Ensino Médio" },
  { label: "Técnico", icon: <Engineering />, value: "Técnico" },
  { label: "Graduação", icon: <LocalLibrary />, value: "Graduação" },
  { label: "Graduação Tecnológica", icon: <Build />, value: "Graduação tecnológica" },
  { label: "Pós-graduação", icon: <Badge />, value: "Pós-graduação" },
  { label: "Especialização", icon: <Handyman />, value: "Especialização" },
  { label: "Mestrado", icon: <Science />, value: "Mestrado" },
  { label: "Doutorado", icon: <Science />, value: "Doutorado" },
  { label: "MBA", icon: <Work />, value: "MBA" },
];

export const TIME_OPTIONS = [
  { value: "morning", label: "Manhã" },
  { value: "afternoon", label: "Tarde" },
  { value: "night", label: "Noite" },
  { value: "full_time", label: "Integral" },
];

export const DOCUMENT_TYPES = [
  { value: "RG", label: "RG" },
  { value: "CNH", label: "CNH" },
  { value: "Certidão de Nascimento", label: "Certidão de Nascimento" },
  { value: "Passaporte", label: "Passaporte" },
  { value: "Carteira de Trabalho", label: "Carteira de Trabalho" },
];

export const SHELVED_OPTIONS = [
  { value: false, label: "Não arquivado" },
  { value: true, label: "Arquivado" },
];

export const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Nome completo é obrigatório"),
  cpf: Yup.string()
    .required("CPF é obrigatório")
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "CPF deve estar no formato 000.000.000-00"),
  phoneNumber: Yup.string().required("Telefone é obrigatório"),
  birthDate: Yup.string()
    .required("Data de nascimento é obrigatória")
    .matches(/^\d{2}\/\d{2}\/\d{4}$/, "Data de nascimento inválida"),
  documentType: Yup.string().required("Tipo de documento é obrigatório"),
  documentNumber: Yup.string().required("Número do documento é obrigatório"),
  cep: Yup.string()
    .required("CEP é obrigatório")
    .matches(/^\d{5}-\d{3}$/, "CEP deve estar no formato 00000-000"),
  stateId: Yup.string().required("Estado é obrigatório"),
  cityId: Yup.string().required("Cidade é obrigatória"),
  streetName: Yup.string().required("Nome da rua é obrigatório"),
  streetNumber: Yup.string().required("Número é obrigatório"),
  neighborhood: Yup.string().required("Bairro é obrigatório"),
  institutionName: Yup.string().required("Instituição é obrigatória"),
  customCourse: Yup.string().required("Curso é obrigatório"),
  registrationNumber: Yup.string().test(
    "registrationNumber-required",
    "Número de registro é obrigatório",
    function (value) {
      const { registrationNotProvided } = this.parent;
      return registrationNotProvided ? true : !!value;
    }
  ),
  courseType: Yup.string().required("Tipo de curso é obrigatório"),
  period: Yup.number().min(1).max(10).required("Período é obrigatório"),
  time: Yup.string().required("Turno é obrigatório"),
  status: Yup.string().required("Status é obrigatório"),
});